import { useSelector } from 'react-redux';

import { isInitialDataLoadedSelector, userSelector } from './store/selectors';
import { usePendo } from './usePendo.hook';

import config from '../config';

export const Pendo = () => {
  const user = useSelector(userSelector);
  const isInitialDataLoaded = useSelector(isInitialDataLoadedSelector);

  usePendo(config.PENDO_KEY, user && {
    customerId: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
  }, !isInitialDataLoaded, false);

  return null;
};
